// import React, { useEffect, useState, useRef } from "react";
// import {
//   Navbar,
//   Nav,
//   Container,
//   Offcanvas,
//   Form,
//   FormControl,
//   Button,
//   InputGroup,
// } from "react-bootstrap";
// import { Link, useNavigate } from "react-router-dom";
// import { FaUser, FaShoppingCart, FaSearch } from "react-icons/fa";
// import { getCategories, getProducts } from "../api/apiendpoint";
// import { BASE_URL } from '../api/apiendpoint';
// import { useAuth } from "../context/AuthContext";
// import { useCart } from "../context/CartContext";
// import Logo from "../images/cropped-Farmhouse-final-logo.png";
// import "./Navbar.css";

// const ResponsiveNavbar = () => {
//   const [showMenu, setShowMenu] = useState(false);
//   const [hovered, setHovered] = useState(null);
//   const [categories, setCategories] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [products, setProducts] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [showSearchResults, setShowSearchResults] = useState(false);

//   const { user, logoutUser } = useAuth();
//   const { cartItems } = useCart();
//   const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);
//   const navigate = useNavigate();
//   const searchRef = useRef();
//   const mobileSearchRef = useRef();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setCategories(await getCategories());
//         setProducts(await getProducts());
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   useEffect(() => {
//     if (searchQuery.trim() === "") {
//       setFilteredProducts([]);
//       setShowSearchResults(false);
//       return;
//     }
//     const filtered = products.filter((p) =>
//       p.product_name.toLowerCase().includes(searchQuery.toLowerCase())
//     );
//     setFilteredProducts(filtered);
//     setShowSearchResults(true);
//   }, [searchQuery, products]);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         (searchRef.current && !searchRef.current.contains(event.target)) &&
//         (mobileSearchRef.current && !mobileSearchRef.current.contains(event.target))
//       ) {
//         setShowSearchResults(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const toggleMenu = () => setShowMenu(!showMenu);
//   const closeMenu = () => setShowMenu(false);
  
//   const handleLogout = async () => {
//     try {
//       await logoutUser();
//       closeMenu();
//     } catch (error) {
//       console.error("Error logging out:", error);
//     }
//   };

//   const handleSearchChange = (e) => setSearchQuery(e.target.value);
  
//   const handleProductClick = (product) => {
//     console.log("Product clicked:", product); // Debug log
//     setSearchQuery("");
//     setShowSearchResults(false);
//     // Ensure we're navigating with the correct product ID
//     if (product && product.id) {
//       navigate(`/product/${product.id}`);
//     } else {
//       console.error("Product ID is missing:", product);
//     }
//   };

//   const handleSearchFocus = () => {
//     if (filteredProducts.length > 0) {
//       setShowSearchResults(true);
//     }
//   };

//   // Common search results component
//   const SearchResults = ({ className = "", style = {} }) => (
//     <div 
//       className={`bg-white shadow rounded mt-1 ${className}`}
//       style={{ 
//         maxHeight: "300px", 
//         overflowY: "auto", 
//         zIndex: 1050, 
//         width: "100%", 
//         boxSizing: "border-box", 
//         padding: "8px",
//         ...style 
//       }}
//     >
//       {filteredProducts.map((product) => (
//         <div
//           key={product.id}
//           onClick={() => handleProductClick(product)}
//           style={{ 
//             cursor: "pointer", 
//             padding: "10px 15px", 
//             marginBottom: "8px", 
//             borderRadius: "8px", 
//             boxShadow: "0 1px 4px rgba(0,0,0,0.1)", 
//             display: "flex", 
//             alignItems: "center", 
//             gap: "12px",
//             transition: "background-color 0.2s ease"
//           }}
//           onMouseEnter={(e) => e.target.style.backgroundColor = "#f8f9fa"}
//           onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
//         >
//           {product.images?.length > 0 && (
//             <img
//               src={`${BASE_URL}${product.images[0].product_img.replace(/^\/+/g, "")}`}
//               alt={product.product_name}
//               style={{ 
//                 width: "40px", 
//                 height: "40px", 
//                 objectFit: "cover", 
//                 borderRadius: "6px" 
//               }}
//               onError={(e) => {
//                 e.target.style.display = 'none';
//               }}
//             />
//           )}
//           <div>
//             <div style={{ 
//               fontWeight: "600", 
//               fontSize: "0.9rem", 
//               color: "#333" 
//             }}>
//               {product.product_name}
//             </div>
//             {product.product_price && (
//               <div style={{ 
//                 fontSize: "0.8rem", 
//                 color: "#666" 
//               }}>
//                 ${product.product_price.toFixed(2)}
//               </div>
//             )}
//           </div>
//         </div>
//       ))}
//       {filteredProducts.length === 0 && searchQuery.trim() !== "" && (
//         <div style={{ 
//           padding: "15px", 
//           textAlign: "center", 
//           color: "#666", 
//           fontSize: "0.9rem" 
//         }}>
//           No products found for "{searchQuery}"
//         </div>
//       )}
//     </div>
//   );

//   return (
//     <>
//       <Navbar fixed="top" className="shadow-sm border-bottom py-2 logo">
//         <Container fluid className="d-flex align-items-center justify-content-between">
//           <Button variant="light" className="d-lg-none border-0 px-2 nav-cart" onClick={toggleMenu}>
//             ☰
//           </Button>
//           <div className="d-lg-none" style={{ width: "40px" }}></div>
          
//           <div className="d-flex flex-column justify-content-center align-items-center mx-auto mx-lg-0">
//             <Link to="/" className="text-decoration-none">
//               <img src={Logo} alt="Logo" style={{ height: "50px" }} />
//             </Link>
//           </div>

//           {/* Desktop Search Bar */}
//           <div className="d-none d-lg-flex align-items-center justify-content-center flex-grow-1 px-4 position-relative" ref={searchRef}>
//             <Form className="w-100">
//               <InputGroup className="mx-auto" style={{ maxWidth: "500px" }}>
//                 <FormControl
//                   type="search"
//                   placeholder="Search products..."
//                   aria-label="Search"
//                   className="border-dark"
//                   value={searchQuery}
//                   onChange={handleSearchChange}
//                   onFocus={handleSearchFocus}
//                   autoComplete="off"
//                 />
//                 <InputGroup.Text className="bg-white border-start-0">
//                   <FaSearch className="text-success" />
//                 </InputGroup.Text>
//               </InputGroup>
//             </Form>

//             {showSearchResults && (
//               <SearchResults 
//                 className="position-absolute"
//                 style={{ 
//                   top: "100%", 
//                   left: 0, 
//                   right: 0 
//                 }}
//               />
//             )}
//           </div>

//           <div className="d-flex align-items-center gap-3 ms-3">
//             {user ? (
//               <div className="dropdown">
//                 <button 
//                   className="btn btn-sm btn-outline-dark dropdown-toggle" 
//                   id="userDropdown" 
//                   data-bs-toggle="dropdown"
//                   aria-expanded="false"
//                 >
//                   {user.username}
//                 </button>
//                 <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
//                   <li>
//                     <button className="dropdown-item" onClick={handleLogout}>
//                       Logout
//                     </button>
//                   </li>
//                 </ul>
//               </div>
//             ) : (
//               <Link to="/login" className="btn btn-sm btn-outline-dark">
//                 Login
//               </Link>
//             )}
//             <div 
//               style={{ position: "relative", cursor: "pointer" }} 
//               onClick={() => navigate("/cart")}
//               role="button"
//               tabIndex={0}
//               onKeyDown={(e) => {
//                 if (e.key === 'Enter' || e.key === ' ') {
//                   navigate("/cart");
//                 }
//               }}
//             >
//               <FaShoppingCart style={{ color: "black" }} />
//               {cartCount > 0 && (
//                 <span 
//                   className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success" 
//                   style={{ fontSize: "0.6em" }}
//                 >
//                   {cartCount}
//                 </span>
//               )}
//             </div>
//           </div>
//         </Container>
//       </Navbar>

//       {/* Desktop Category Menu */}
//       <div className="d-none d-lg-block bg-black text-white py-2 shadow-sm" style={{ marginTop: "68px" }}>
//         <Container>
//           <Nav className="gap-4 fw-semibold text-uppercase justify-content-center">
//             <Nav.Item>
//               <Link to="/" className="nav-link text-white">Home</Link>
//             </Nav.Item>
//             <Nav.Item 
//               className="position-relative" 
//               onMouseEnter={() => setHovered("Products")} 
//               onMouseLeave={() => setHovered(null)}
//             >
//               <span className="nav-link text-white" style={{ cursor: "pointer" }}>
//                 Products
//               </span>
//               {hovered === "Products" && (
//                 <div 
//                   className="position-absolute bg-dark shadow p-3 rounded" 
//                   style={{ 
//                     top: "100%", 
//                     left: "50%", 
//                     transform: "translateX(-50%)", 
//                     zIndex: 1000, 
//                     minWidth: "220px" 
//                   }}
//                 >
//                   {categories.map((cat) => (
//                     <Link 
//                       key={cat.id} 
//                       to={`/category/${cat.name_category.toLowerCase()}`} 
//                       className="dropdown-item text-white"
//                     >
//                       {cat.name_category}
//                     </Link>
//                   ))}
//                 </div>
//               )}
//             </Nav.Item>
//             <Nav.Item>
//               <Link to="/cook-with-us" className="nav-link text-white">Cook With Us</Link>
//             </Nav.Item>
//             <Nav.Item>
//               <Link to="/my-orders" className="nav-link text-white">My Orders</Link>
//             </Nav.Item>
//           </Nav>
//         </Container>
//       </div>

//       {/* Mobile Search Bar */}
//       <div 
//         className="d-lg-none bg-light px-3 pt-3 pb-2 shadow-sm position-relative" 
//         ref={mobileSearchRef} 
//         style={{ marginTop: "68px", zIndex: 1020 }}
//       >
//         <Form className="w-100">
//           <InputGroup className="mx-auto" style={{ maxWidth: "500px" }}>
//             <FormControl
//               type="search"
//               placeholder="Search products..."
//               aria-label="Search"
//               className="border-dark"
//               value={searchQuery}
//               onChange={handleSearchChange}
//               onFocus={handleSearchFocus}
//               autoComplete="off"
//             />
//             <InputGroup.Text className="bg-white border-start-0">
//               <FaSearch className="text-success" />
//             </InputGroup.Text>
//           </InputGroup>
//         </Form>

//         {showSearchResults && <SearchResults />}
//       </div>

//       {/* Mobile Menu Offcanvas */}
//       <Offcanvas show={showMenu} onHide={toggleMenu} placement="start">
//         <Offcanvas.Header closeButton>
//           <Offcanvas.Title>
//             <Link to="/" onClick={closeMenu}>
//               <img src={Logo} alt="Logo" style={{ height: "50px" }} />
//             </Link>
//           </Offcanvas.Title>
//         </Offcanvas.Header>
//         <Offcanvas.Body>
//           <Link to="/" className="d-block mb-2 text-dark" onClick={closeMenu}>
//             Home
//           </Link>
//           <h6 className="fw-bold text-uppercase">Products</h6>
//           {categories.map((cat) => (
//             <div key={cat.id} className="ps-2 py-1">
//               <Link 
//                 to={`/category/${cat.name_category.toLowerCase()}`} 
//                 className="text-decoration-none text-dark" 
//                 onClick={closeMenu}
//               >
//                 {cat.name_category}
//               </Link>
//             </div>
//           ))}
//           <hr />
//           <Link to="/cook-with-us" className="d-block mb-2 text-dark" onClick={closeMenu}>
//             Cook With Us
//           </Link>
//           <Link to="/my-orders" className="d-block mb-2 text-dark" onClick={closeMenu}>
//             My Orders
//           </Link>
//           <Link to="/cart" className="d-block mt-3 text-dark" onClick={closeMenu}>
//             Cart ({cartCount})
//           </Link>
//           <div className="mt-3">
//             {user ? (
//               <button className="btn btn-sm btn-outline-dark" onClick={handleLogout}>
//                 Logout
//               </button>
//             ) : (
//               <Link to="/login" className="btn btn-sm btn-outline-dark">
//                 Login
//               </Link>
//             )}
//           </div>
//         </Offcanvas.Body>
//       </Offcanvas>
//     </>
//   );
// };

// export default ResponsiveNavbar;




import React, { useEffect, useState, useRef } from "react";
import {
  Navbar,
  Nav,
  Container,
  Offcanvas,
  Form,
  FormControl,
  Button,
  InputGroup,
  Badge,
  Dropdown,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { 
  FaUser, 
  FaShoppingCart, 
  FaSearch, 
  FaHeart,
  FaBars,
  FaUserCircle,
  FaSignOutAlt,
  FaBoxOpen,
  FaHome,
  FaUtensils,
  FaChevronDown,
  FaTimes
} from "react-icons/fa";
import { getCategories, getProducts } from "../api/apiendpoint";
import { BASE_URL } from '../api/apiendpoint';
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import Logo from "../images/cropped-Farmhouse-final-logo.png";
import "./Navbar.css";

const ResponsiveNavbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [hovered, setHovered] = useState(null);
  const [categories, setCategories] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const { user, logoutUser } = useAuth();
  const { cartItems } = useCart();
  const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);
  const navigate = useNavigate();
  const searchRef = useRef();
  const mobileSearchRef = useRef();
  const hoverTimeoutRef = useRef();

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setCategories(await getCategories());
        setProducts(await getProducts());
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredProducts([]);
      setShowSearchResults(false);
      return;
    }
    const filtered = products.filter((p) =>
      p.product_name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredProducts(filtered);
    setShowSearchResults(true);
  }, [searchQuery, products]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        (searchRef.current && !searchRef.current.contains(event.target)) &&
        (mobileSearchRef.current && !mobileSearchRef.current.contains(event.target))
      ) {
        setShowSearchResults(false);
        setIsSearchFocused(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleMenu = () => setShowMenu(!showMenu);
  const closeMenu = () => setShowMenu(false);
  
  const handleLogout = async () => {
    try {
      await logoutUser();
      closeMenu();
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  const handleSearchChange = (e) => setSearchQuery(e.target.value);
  
  const handleProductClick = (product) => {
    console.log("Product clicked:", product);
    setSearchQuery("");
    setShowSearchResults(false);
    setIsSearchFocused(false);
    if (product && product.id) {
      navigate(`/product/${product.id}`);
    } else {
      console.error("Product ID is missing:", product);
    }
  };

  const handleSearchFocus = () => {
    setIsSearchFocused(true);
    if (filteredProducts.length > 0) {
      setShowSearchResults(true);
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
    setFilteredProducts([]);
    setShowSearchResults(false);
    setIsSearchFocused(false);
  };

  // Enhanced hover handlers for dropdown
  const handleMouseEnter = (item) => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
    setHovered(item);
  };

  const handleMouseLeave = () => {
    hoverTimeoutRef.current = setTimeout(() => {
      setHovered(null);
    }, 200); // 200ms delay before hiding
  };

  const handleDropdownMouseEnter = () => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
  };

  const handleDropdownMouseLeave = () => {
    hoverTimeoutRef.current = setTimeout(() => {
      setHovered(null);
    }, 200);
  };

  // Enhanced search results component
  const SearchResults = ({ className = "", style = {} }) => (
    <div 
      className={`search-results ${className}`}
      style={{ 
        position: "absolute",
        top: "100%",
        left: 0,
        right: 0,
        backgroundColor: "white",
        borderRadius: "12px",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
        border: "1px solid #e9ecef",
        maxHeight: "400px", 
        overflowY: "auto", 
        zIndex: 1050,
        marginTop: "8px",
        ...style 
      }}
    >
      {filteredProducts.length > 0 ? (
        <>
          <div style={{ 
            padding: "12px 16px", 
            borderBottom: "1px solid #f8f9fa",
            fontSize: "0.85rem",
            fontWeight: "600",
            color: "#6c757d",
            textTransform: "uppercase",
            letterSpacing: "0.5px"
          }}>
            {filteredProducts.length} Product{filteredProducts.length !== 1 ? 's' : ''} Found
          </div>
          {filteredProducts.map((product) => (
            <div
              key={product.id}
              onClick={() => handleProductClick(product)}
              className="search-result-item"
              style={{ 
                cursor: "pointer", 
                padding: "16px", 
                borderBottom: "1px solid #f8f9fa",
                display: "flex", 
                alignItems: "center", 
                gap: "16px",
                transition: "all 0.2s ease",
                ":hover": {
                  backgroundColor: "#f8f9fa"
                }
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
                e.currentTarget.style.transform = "translateX(4px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "transparent";
                e.currentTarget.style.transform = "translateX(0)";
              }}
            >
              {product.images?.length > 0 && (
                <div style={{ position: "relative" }}>
                  <img
                    src={`${BASE_URL}${product.images[0].product_img.replace(/^\/+/g, "")}`}
                    alt={product.product_name}
                    style={{ 
                      width: "48px", 
                      height: "48px", 
                      objectFit: "cover", 
                      borderRadius: "8px",
                      border: "1px solid #e9ecef"
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              )}
              <div style={{ flex: 1 }}>
                <div style={{ 
                  fontWeight: "600", 
                  fontSize: "0.95rem", 
                  color: "#212529",
                  marginBottom: "4px"
                }}>
                  {product.product_name}
                </div>
                {product.product_price && (
                  <div style={{ 
                    fontSize: "0.85rem", 
                    color: "#28a745",
                    fontWeight: "600"
                  }}>
                    ${product.product_price.toFixed(2)}
                  </div>
                )}
              </div>
            </div>
          ))}
        </>
      ) : (
        <div style={{ 
          padding: "32px 16px", 
          textAlign: "center", 
          color: "#6c757d", 
          fontSize: "0.9rem" 
        }}>
          <FaSearch style={{ fontSize: "2rem", marginBottom: "16px", opacity: 0.3 }} />
          <div>No products found for "{searchQuery}"</div>
          <div style={{ fontSize: "0.8rem", marginTop: "8px" }}>
            Try different keywords or browse our categories
          </div>
        </div>
      )}
    </div>
  );

  return (
    <>
      {/* Main Navbar */}
      <Navbar 
        fixed="top" 
        className={`main-navbar ${isScrolled ? 'scrolled' : ''}`}
        style={{
          backgroundColor: "#7dbfa2",
          borderBottom: "1px solid #6aab8e",
          boxShadow: isScrolled ? "0 4px 12px rgba(0, 0, 0, 0.1)" : "0 2px 4px rgba(0, 0, 0, 0.05)",
          transition: "all 0.3s ease",
          padding: "8px 0"
        }}
      >
        <Container fluid className="px-3">
          <div className="d-flex align-items-center justify-content-between w-100">
            
            {/* Mobile Menu Toggle */}
            <Button 
              variant="outline-light" 
              className="d-lg-none border-0 " 
              onClick={toggleMenu}
              style={{ 
                backgroundColor: "black",
                border: "1px solid rgba(255, 255, 255, 0.3)",
                color: "white",
                padding: "8px 12px",
                borderRadius: "8px"
              }}
            >
              <FaBars size={18} />
            </Button>
            
            {/* Logo */}
            <div className="logo-container">
              <Link to="/" className="text-decoration-none">
                <img 
                  src={Logo} 
                  alt="Farmhouse Logo" 
                  style={{ 
                    height: "65px",
                    transition: "transform 0.2s ease"
                  }}
                  onMouseEnter={(e) => e.target.style.transform = "scale(1.05)"}
                  onMouseLeave={(e) => e.target.style.transform = "scale(1)"}
                />
              </Link>
            </div>

            {/* Desktop Search Bar */}
            <div 
              className="d-none d-lg-flex align-items-center flex-grow-1 px-4 position-relative" 
              ref={searchRef}
              style={{ maxWidth: "600px" }}
            >
              <Form className="w-100">
                <InputGroup 
                  className="search-input-group"
                  style={{ 
                    borderRadius: "12px",
                    overflow: "hidden",
                    border: isSearchFocused ? "2px solid #28a745" : "2px solid #e9ecef",
                    transition: "border-color 0.2s ease"
                  }}
                >
                  <FormControl
                    type="search"
                    placeholder="Search for products, categories..."
                    aria-label="Search"
                    className="border-0 search-input"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    onFocus={handleSearchFocus}
                    autoComplete="off"
                    style={{
                      fontSize: "0.95rem",
                      padding: "14px 16px",
                      backgroundColor: "#f8f9fa",
                      border: "none",
                      outline: "none",
                      boxShadow: "none"
                    }}
                  />
                  {searchQuery && (
                    <Button
                      variant="link"
                      className="border-0 px-2"
                      onClick={clearSearch}
                      style={{ 
                        backgroundColor: "transparent",
                        color: "#6c757d"
                      }}
                    >
                      <FaTimes size={14} />
                    </Button>
                  )}
                  <InputGroup.Text 
                    className="search-button"
                    style={{ 
                      backgroundColor: "#7dbfa2",
                      border: "none",
                      color: "white",
                      padding: "0 16px",
                      cursor: "pointer"
                    }}
                  >
                    <FaSearch size={16} />
                  </InputGroup.Text>
                </InputGroup>
              </Form>

              {showSearchResults && <SearchResults />}
            </div>

            {/* Right Side Actions */}
            <div className=" d-flex align-items-center gap-3">
              
              {/* User Account */}
              <div className="d-none d-md-flex align-items-center ">
              {user ? (
                <Dropdown align="end">
                  <Dropdown.Toggle 
                    variant="outline-light" 
                    className="d-flex align-items-center gap-2 border-0"
                    style={{ 
                      backgroundColor: "black",
                      color: "white",
                      border: "1px solid rgba(255, 255, 255, 0.3)",
                      padding: "8px 12px",
                      borderRadius: "8px"
                    }}
                  >
                    <FaUserCircle size={20} />
                    <span className="d-none d-md-inline">{user.username}</span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="shadow-lg border-0" style={{ borderRadius: "12px" }}>
                    <Dropdown.Item 
                      onClick={() => navigate("/profile")}
                      className="d-flex align-items-center gap-2 py-2"
                    >
                      <FaUser size={14} />
                      Profile
                    </Dropdown.Item>
                    <Dropdown.Item 
                      onClick={() => navigate("/my-orders")}
                      className="d-flex align-items-center gap-2 py-2"
                    >
                      <FaBoxOpen size={1} />
                      My Orders
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item 
                      onClick={handleLogout}
                      className="d-flex align-items-center gap-2 py-2 text-danger"
                    >
                      <FaSignOutAlt size={14} />
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <Link 
                  to="/login" 
                  className="btn btn-outline-light d-flex align-items-center gap-2"
                  style={{ 
                    padding: "8px 16px",
                    borderRadius: "8px",
                    textDecoration: "none",
                    color: "white",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    backgroundColor: "black"
                  }}
                >
                  <FaUser size={16} />
                  <span className="d-none d-md-inline">Login</span>
                </Link>
              )}
              </div>

              {/* Cart */}
              <Button
                variant="light"
                className="d-flex align-items-center gap-2 position-relative"
                onClick={() => navigate("/cart")}
                style={{ 
                  padding: "10px 16px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor: "black",
                  color: "white",
                  fontWeight: "600"
                }}
              >
                <FaShoppingCart size={16} />
                <span className="d-none d-md-inline">Cart</span>
                {cartCount > 0 && (
                  <Badge 
                    bg="danger" 
                    pill 
                    className="position-absolute top-0 start-100 translate-middle"
                    style={{ fontSize: "0.7rem" }}
                  >
                    {cartCount}
                  </Badge>
                )}
              </Button>
            </div>
          </div>
        </Container>
      </Navbar>

      {/* Desktop Category Navigation */}
      <div 
        className="d-none d-lg-block category-nav"
        style={{ 
          marginTop: "72px",
          backgroundColor: "black",
          borderBottom: "1px solid #495057"
        }}
      >
        <Container>
          <Nav className="py-3 justify-content-center">
            <Nav.Item className="mx-2">
              <Link 
                to="/" 
                className="nav-link text-light d-flex align-items-center gap-2 px-3 py-2"
                style={{ 
                  borderRadius: "8px",
                  transition: "all 0.2s ease",
                  textDecoration: "none"
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = "#495057"}
                onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
              >
                <FaHome size={16} />
                Home
              </Link>
            </Nav.Item>
            
            <Nav.Item 
              className="mx-2 position-relative" 
              onMouseEnter={() => handleMouseEnter("Products")} 
              onMouseLeave={handleMouseLeave}
            >
              <span 
                className="nav-link text-light d-flex align-items-center gap-2 px-3 py-2"
                style={{ 
                  cursor: "pointer",
                  borderRadius: "8px",
                  transition: "all 0.2s ease",
                  backgroundColor: hovered === "Products" ? "#495057" : "transparent"
                }}
              >
                <FaBoxOpen size={16} />
                Products
                <FaChevronDown size={12} />
              </span>
              {hovered === "Products" && (
                <div 
                  className="position-absolute bg-white shadow-lg rounded-3 p-3" 
                  style={{ 
                    top: "100%", 
                    left: "50%", 
                    transform: "translateX(-50%)", 
                    zIndex: 1000, 
                    minWidth: "280px",
                    marginTop: "8px",
                    border: "1px solid #e9ecef"
                  }}
                  onMouseEnter={handleDropdownMouseEnter}
                  onMouseLeave={handleDropdownMouseLeave}
                >
                  <div className="row g-0">
                    {categories.map((cat, index) => (
                      <div key={cat.id} className="col-12">
                        <Link 
                          to={`/category/${cat.name_category.toLowerCase()}`} 
                          className="dropdown-item d-flex align-items-center gap-2 px-3 py-2 text-dark"
                          style={{ 
                            borderRadius: "8px",
                            transition: "all 0.2s ease",
                            textDecoration: "none",
                            fontSize: "0.9rem"
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = "#f8f9fa"}
                          onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
                        >
                          {cat.name_category}
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </Nav.Item>
            
            <Nav.Item className="mx-2">
              <Link 
                to="/cook-with-us" 
                className="nav-link text-light d-flex align-items-center gap-2 px-3 py-2"
                style={{ 
                  borderRadius: "8px",
                  transition: "all 0.2s ease",
                  textDecoration: "none"
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = "#495057"}
                onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
              >
                <FaUtensils size={16} />
                Cook With Us
              </Link>
            </Nav.Item>
          </Nav>
        </Container>
      </div>

      {/* Mobile Search Bar */}
      <div 
        className="d-lg-none mobile-search"
        ref={mobileSearchRef}
        style={{ 
          marginTop: "72px",
          backgroundColor: "#f8f9fa",
          borderBottom: "1px solid #e9ecef",
          padding: "16px",
          position: "relative",
          zIndex: 1020
        }}
      >
        <Form>
          <InputGroup 
            style={{ 
              borderRadius: "12px",
              overflow: "hidden",
              border: isSearchFocused ? "2px solid #28a745" : "2px solid #e9ecef",
              transition: "border-color 0.2s ease"
            }}
          >
            <FormControl
              type="search"
              placeholder="Search products..."
              aria-label="Search"
              className="border-0"
              value={searchQuery}
              onChange={handleSearchChange}
              onFocus={handleSearchFocus}
              autoComplete="off"
              style={{
                fontSize: "0.95rem",
                padding: "14px 16px",
                backgroundColor: "white",
                border: "none",
                outline: "none",
                boxShadow: "none"
              }}
            />
            {searchQuery && (
              <Button
                variant="link"
                className="border-0 px-2"
                onClick={clearSearch}
                style={{ 
                  backgroundColor: "white",
                  color: "#6c757d"
                }}
              >
                <FaTimes size={14} />
              </Button>
            )}
            <InputGroup.Text 
              style={{ 
                backgroundColor: "#7dbfa2",
                border: "none",
                color: "white",
                padding: "0 16px"
              }}
            >
              <FaSearch size={16} />
            </InputGroup.Text>
          </InputGroup>
        </Form>

        {showSearchResults && <SearchResults style={{ position: "absolute", left: "16px", right: "16px" }} />}
      </div>

      {/* Mobile Menu Offcanvas */}
      <Offcanvas 
        show={showMenu} 
        onHide={toggleMenu} 
        placement="start"
        className="mobile-menu"
        style={{ width: "300px" }}
      >
        <Offcanvas.Header 
          closeButton 
          className="border-bottom"
          style={{ padding: "20px 24px" }}
        >
          <Offcanvas.Title>
            <Link to="/" onClick={closeMenu} className="text-decoration-none">
              <img 
                src={Logo} 
                alt="Farmhouse Logo" 
                style={{ height: "48px" }} 
              />
            </Link>
          </Offcanvas.Title>
        </Offcanvas.Header>
        
        <Offcanvas.Body style={{ padding: "24px" }}>
          <div className="d-flex flex-column gap-3">
            
            {/* User Info */}
            {user && (
              <div className="bg-light p-3 rounded-3 mb-3">
                <div className="d-flex align-items-center gap-2">
                  <FaUserCircle size={24} />
                  <div>
                    <div className="fw-bold">{user.username}</div>
                    <small className="text-muted">Welcome back!</small>
                  </div>
                </div>
              </div>
            )}

            {/* Navigation Links */}
            <Link 
              to="/" 
              className="d-flex align-items-center gap-3 text-dark text-decoration-none p-3 rounded-3"
              onClick={closeMenu}
              style={{ transition: "background-color 0.2s ease" }}
              onMouseEnter={(e) => e.target.style.backgroundColor = "#f8f9fa"}
              onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
            >
              <FaHome size={20} />
              <span className="fw-semibold">Home</span>
            </Link>
            
            <div className="border-bottom pb-3 mb-3 p-3">
              <h6 className="fw-bold text-uppercase mb-3 text-muted">Products</h6>
              {categories.map((cat) => (
                <Link 
                  key={cat.id}
                  to={`/category/${cat.name_category.toLowerCase()}`} 
                  className="d-block text-decoration-none text-dark py-2  rounded-3 p-3"
                  onClick={closeMenu}
                  style={{ 
                    marginBottom: "4px",
                    transition: "background-color 0.2s ease"
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = "#f8f9fa"}
                  onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
                >
                  {cat.name_category}
                </Link>
              ))}
            </div>
            
            <Link 
              to="/cook-with-us" 
              className="d-flex align-items-center gap-3 text-dark text-decoration-none p-3 rounded-3"
              onClick={closeMenu}
              style={{ transition: "background-color 0.2s ease" }}
              onMouseEnter={(e) => e.target.style.backgroundColor = "#f8f9fa"}
              onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
            >
              <FaUtensils size={20} />
              <span className="fw-semibold">Cook With Us</span>
            </Link>
            
            <Link 
              to="/my-orders" 
              className="d-flex align-items-center gap-3 text-dark text-decoration-none p-3 rounded-3"
              onClick={closeMenu}
              style={{ transition: "background-color 0.2s ease" }}
              onMouseEnter={(e) => e.target.style.backgroundColor = "#f8f9fa"}
              onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
            >
              <FaBoxOpen size={20} />
              <span className="fw-semibold">My Orders</span>
            </Link>
            
            <Link 
              to="/cart" 
              className="d-flex align-items-center gap-3 text-dark text-decoration-none p-3 rounded-3 position-relative"
              onClick={closeMenu}
              style={{ transition: "background-color 0.2s ease" }}
              onMouseEnter={(e) => e.target.style.backgroundColor = "#f8f9fa"}
              onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
            >
              <FaShoppingCart size={20} />
              <span className="fw-semibold">Cart</span>
              {cartCount > 0 && (
                <Badge bg="success" pill className="ms-auto">
                  {cartCount}
                </Badge>
              )}
            </Link>
            
            {/* Auth Actions */}
            <div className="mt-auto pt-3 border-top p-3">
              {user ? (
                <Button 
                  variant="outline-danger" 
                  className="w-100 d-flex align-items-center justify-content-center gap-2"
                  onClick={handleLogout}
                  style={{ padding: "12px", borderRadius: "8px" }}
                >
                  <FaSignOutAlt size={16} />
                  Logout
                </Button>
              ) : (
                <Link 
                  to="/login" 
                  className="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2"
                  style={{ 
                    padding: "12px", 
                    borderRadius: "8px", 
                    textDecoration: "none",
                    backgroundColor: "#7dbfa2",
                    borderColor: "#7dbfa2"
                  }}
                >
                  <FaUser size={16} />
                  Login
                </Link>
              )}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default ResponsiveNavbar;